// ArticlePage.js — /articles/:slug. Renders one article from articles/index.js
// with its SEO tags and Article structured data; unknown slugs get the 404 page.

import React from "react";
import { useParams } from "react-router-dom";
import SEO from "./components/SEO";
import AdSlot from "./components/AdSlot";
import { CtaRow, PageHeader, ProsePage } from "./components/Prose";
import NotFoundPage from "./NotFoundPage";
import { articleBySlug, formatArticleDate } from "./articles";

const SITE_URL = "https://premierleaguescorigami.com";

export default function ArticlePage() {
  const { slug } = useParams();
  const article = articleBySlug(slug);
  if (!article) return <NotFoundPage />;
  const { title, description, lede, date, minutes, Body } = article;
  const path = `/articles/${slug}`;

  return (
    <ProsePage>
      <SEO
        title={title}
        description={description}
        path={path}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: title,
          description,
          datePublished: date,
          dateModified: date,
          mainEntityOfPage: `${SITE_URL}${path}`,
          author: { "@type": "Person", name: "Mason Maier", url: `${SITE_URL}/about` },
          publisher: { "@type": "Organization", name: "Premier League Scorigami", url: SITE_URL },
        }}
      />
      <article>
        <PageHeader eyebrow="Articles" title={title} meta={`By Mason Maier · ${formatArticleDate(date)} · ${minutes} min read`} lede={lede} />
        <Body />
      </article>
      <AdSlot position="article" />
      <CtaRow
        links={[
          { to: "/", label: "Explore the grid", primary: true },
          { to: "/records", label: "Records" },
          { to: "/articles", label: "More articles" },
        ]}
      />
    </ProsePage>
  );
}
